import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, CardContent, Avatar, Grid, Typography, } from '@material-ui/core/';
import moment from 'moment'
import rating from '../../../global/imagenes/rating.png';
import { COLORES_ESTADO } from "./../helper";


const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: "100%",
    minHeight: "50px",
    height: "300px",
  },
  image: {
    width: '80px',
    maxWidth: '80px',
    minWidth: '80px',
    height: "80px",
  },
  content_text: {
    padding: "0px 0px 0px 10px",
  },
  content_img: {
    textAlign: 'center',
    height: "150px",
  },

}));

export default function BienestarActivo({ titulo, fecha, descripcion, estado, categoria, tipo }) {
    let fecha_r = moment(fecha).format('YYYY-MM-DD, h:mm a');
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardHeader
                avatar={<Avatar aria-label="recipe" style={COLORES_ESTADO[estado.codigo] || { backgroundColor: '#B8B8B8', color: '#D9D7D7' }}> {estado.nombre.charAt(0).toUpperCase()} </Avatar>}
                title={titulo}
                subheader={fecha_r}
            />
            <CardContent>
                <Grid container direction={'row'} justifyContent={'center'}>
                    <Grid item xs={12} sm={12} md={12} className={classes.content_img}>
                        <img src={rating} className={classes.image} alt='Imagen Tipo' />
                        <Typography variant="body2" color="textSecondary" component="p" align='justify'>
                            {descripcion}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
